import * as React from "react"
import { Col, Row } from "react-grid-system"
import { useTranslation } from "react-i18next"
import styled from "styled-components"
import H3 from "../../atoms/typography/H3"
import H4 from "../../atoms/typography/H4"
import { slicePieData } from "../../../utils/chart-helpers"
import { theme } from "../../theme"
import PieChart, { ChartsColorScale } from "./PieChart"

interface PieChartDataBoxProps {
  data: Array<any>
}

const PieColorMatchIcon = styled.div<{ color: string }>`
  width: 24.13px;
  height: 24.13px;
  margin-right: 0.5rem;

  background: ${(props) => props.color};
  border-radius: ${(props) => props.theme.borders.buttonRadius};
`

const PieDescription = styled.div`
  padding: 0.5rem;
  display: flex;
  align-items: center;
  word-break: break-all;
  width: 100%;
`

const PieChartDataBox: React.FunctionComponent<PieChartDataBoxProps> = ({ data }) => {
  const { t } = useTranslation()
  const [hoverIndex, setHoverIndex] = React.useState<undefined | number>(undefined)
  const onHoverPie = (index?: number) => {
    setHoverIndex(index)
  }

  const slicedPieData = data && slicePieData(data)

  if (!data) {
    return <div>ERROR</div>
  }

  return (
    <div>
      <Row justify="around" align="center">
        {!slicedPieData || (slicedPieData.length < 1 && <H4 textAlign="center">{t("no_data")}</H4>)}
        <Col md={5}>
          <PieChart data={slicedPieData} onHoverPie={onHoverPie} />
        </Col>
        <Col md={7}>
          <Row>
            {slicedPieData.map((item, index) => {
              return (
                <Col md={6} key={item.label}>
                  <PieDescription>
                    <div>
                      <PieColorMatchIcon color={index === hoverIndex ? theme.colors.yellow : ChartsColorScale[index]} />
                    </div>
                    <H3>{item.label}</H3>
                  </PieDescription>
                </Col>
              )
            })}
          </Row>
        </Col>
      </Row>
    </div>
  )
}

export default PieChartDataBox
